import Name from './Name';
import Created from './Created';
import Updated from './Updated';
import Id from './Id';
import OwnCompany from './OwnCompany'
import Prefix from './Prefix'
import Suffix from './Suffix'

export const labels = {
  Id: 'Id',
  Name: 'Név',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  OwnCompany: 'Iroda',
  Prefix: 'Előtag',
  Suffix: 'Utótag'
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'OwnCompany',
}, {
  value: 'Prefix',
}, {
  value: 'Suffix',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'OwnCompany',
}, {
  value: 'Prefix',
}, {
  value: 'Suffix',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Name,
  Updated,
  Created,
  Id,
  OwnCompany,
  Prefix,
  Suffix,
};
